import React from 'react'
import { ScrollView, Linking, TouchableOpacity, View, ViewStyle, TextStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import DeviceInfo from 'react-native-device-info'
import { useStores } from '@trivie/core'
import { color, iconChevronRight, SvgIcon, Text } from '@trivie/ui-mobile'
import { useHistory } from 'react-router-dom'

export const SettingsList = observer(() => {
  const { userStore } = useStores()
  const { accessCode, logout } = userStore

  const history = useHistory()

  const goToAccountScreen = () => history.push('settings/account')
  const goToNotificationsScreen = () => history.push('settings/notifications')
  const goToSoundMusicScreen = () => history.push('settings/audio')
  const goToReportProblem = () => history.push('settings/report')
  const goToHistoryScreen = () => history.push(`/settings/history`)

  const goToTOS = () => {
    Linking.openURL('https://www.trivie.com/terms-of-service')
  }

  const goToPrivacyPolicy = () => {
    Linking.openURL('https://www.trivie.com/privacy')
  }

  const items = [
    {
      label: 'Settings.Account.header',
      onPress: goToAccountScreen,
      display: true,
    },
    {
      label: 'Profile.quizHistory',
      onPress: goToHistoryScreen,
      display: true,
    },
    {
      label: 'Notifications.header',
      onPress: goToNotificationsScreen,
      display: true,
    },
    {
      label: 'Settings.Sounds.header',
      onPress: goToSoundMusicScreen,
      display: true,
    },
    {
      label: 'Settings.TOS',
      onPress: goToTOS,
      display: true,
    },
    {
      label: 'Settings.PrivacyPolicy',
      onPress: goToPrivacyPolicy,
      display: true,
    },
    {
      label: 'Settings.ReportProblem',
      onPress: goToReportProblem,
      display: true,
    },
  ]

  const renderItem = (item: { label: string; onPress: () => void; display: boolean }) => (
    <View style={LIST_ITEM_CONTAINER}>
      <TouchableOpacity onPress={item.onPress} style={LIST_ITEM_BTN}>
        <View style={LIST_ITEM}>
          <Text variant="label" tx={item.label} />
          <SvgIcon src={iconChevronRight} color={color.shade30} size={24} />
        </View>
      </TouchableOpacity>
    </View>
  )

  return (
    <ScrollView>
      {items.map((item) => renderItem(item))}
      <TouchableOpacity onPress={() => logout()} style={{ flexDirection: 'row' }}>
        <View style={{ ...LIST_ITEM, paddingLeft: 20 }}>
          <Text style={LOGOUT} variant="label" tx="Onboarding.Login.logOut" />
        </View>
      </TouchableOpacity>
      <View style={INFO}>
        <Text
          style={VERSION}
          tx="Settings.Version"
          txOptions={{ versionNum: DeviceInfo.getVersion() }}
          variant="titleEmphasized"
        />
        <Text
          style={WORKSPACE}
          tx="Settings.WorkspaceCode"
          txOptions={{ code: accessCode }}
          variant="titleEmphasized"
        />
      </View>
    </ScrollView>
  )
})

/**
 * Styling
 */
const LIST_ITEM_CONTAINER: ViewStyle = {
  marginHorizontal: 20,
  borderBottomWidth: 1,
  borderBottomColor: color.shade10,
}
const LIST_ITEM: ViewStyle = {
  flexDirection: 'row',
  flex: 1,
  justifyContent: 'space-between',
  alignContent: 'center',
  paddingVertical: 20,
}
const INFO: ViewStyle = {
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'flex-end',
  alignItems: 'center',
  alignContent: 'center',
  paddingVertical: 20,
}
const LIST_ITEM_BTN: ViewStyle = { flexDirection: 'row' }
const VERSION: TextStyle = {
  marginBottom: 10.5,
  fontSize: 12.5,
  fontWeight: '400',
  color: '#808080',
}
const LOGOUT: TextStyle = { color: color.red }
const WORKSPACE: TextStyle = {
  marginBottom: 15.5,
  fontSize: 12.5,
  fontWeight: '400',
  color: '#808080',
}
